import actions from 'redux/actions'
import { getState } from 'redux/core'
import { getCookieValue } from 'helpers'
import { constants, mixpanel } from 'common/helpers'


/**
 * withCart:false,
 * subscriptionOrderNo:SS158,
 * subscription:205271,
 * subscriptionOrder:158,
 * subscriptionSessionFinished:true,
 * orderAmount:1495,
 * totalAmount:1495,
 * token:f10ba650-8b29-4627-abf4-dd4e0261fb8b,
 * nextBillingDate:2018-05-05T00:00:00Z,
 * balance:0,
 * credits:{
 *   total:1,
 *   onBalance:0,
 *   paid:1,
 *   free:0,
 *   free_for_referral:0,
 *   free_for_referee:0,
 *   free_coupon:0,
 *   free_gift:0
 * }
 */
const syncUserAndSubscription = (data) => {
  const {
    paymentType,
    subscriptionOrderNo,
    order,
    orderNo,
    ecommerceOrder,
    ecommerceOrderNo,
    ecommerceIsError,
    ecommerceErrorMsg,
    isTossIn,
    hasLockedProductsAfterSubscription,
  } = data

  mixpanel.track(constants.analyticsEvents.tech.syncUserAndSubscription)

  // TODO remove this logic when new Subscribe page will be complete and remove this logic from Thank you page
  const {
    models: {
      cart: { items: cartItems, totalCount, totalPrice },
      payment: { userShippingAddress: shippingAddress = {}, paymentOption: paymentMethod },
    },
    view: {
      paymentPage: {
        coupon: { code },
        bill: { offer },
        subscription: { price = 0, discount = 0, tax } = {},
        selectedPlan,
      },
    },
  } = getState()

  const newPaymentCouponCode  = getCookieValue(constants.cookieNames.newPaymentCouponCode)

  actions.models.purchaseData.setPaymentData({
    paymentType,
    paymentMethod,
    subscriptionOrderNumber: subscriptionOrderNo,
    ecommerceOrderNumber: ecommerceOrderNo || orderNo,
    ecommerceOrderId: ecommerceOrder || order,
    ecommerceErrorMessage: ecommerceErrorMsg,
    isEcommerceErrorExist: Boolean(ecommerceIsError),
    isTossIn,
    cart: data.cart || cartItems,
    productCount: data.count || totalCount,
    totalAmount: data.totalAmount || totalPrice,
    couponCode: code || offer || newPaymentCouponCode,
    subscriptionPriceWithDiscount: price - discount,
    subscriptionPlan: selectedPlan,
    tax,
    shippingAddress,
    hasLockedProductsAfterSubscription,
  })

  return Promise.all([
    actions.models.me.fetch(),
    actions.models.subscription.fetch(),
  ])
}


export default syncUserAndSubscription
